import { useQuery } from '@tanstack/react-query'
import {
	type GetMMSubmissionDetailsParams,
	httpGetMMSubmissionDetails
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const MM_SUBMISSION_DETAILS_QUERY_KEY = 'mm-submission-details'

export const useGetMMSubmissionDetails = (
	params: GetMMSubmissionDetailsParams = {}
) =>
	useQuery({
		queryKey: [MM_SUBMISSION_DETAILS_QUERY_KEY, params],
		queryFn: () => httpGetMMSubmissionDetails(params)
	})
